import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./sections/Navbar";
import Hero from "./sections/Hero";
import SummerOffer from "./sections/SummerOffer";
import Services from "./sections/Services";
import Reviews from "./sections/Reviews";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
import WhatsAppFloating from "./components/WhatsAppFloating";

const Home = () => {
    return (
        <div className="App bg-haas-cream text-haas-ink font-sans">
            <Navbar />
            <main>
                <Hero />
                <SummerOffer />
                <Services />
                <Reviews />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFloating />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
